import { useT } from "../i18n";
import type { Faktoreinrichtung } from "../daten/faktor";
import "../stile/faktor.css";

/* ══════════════════════════════════════════════════════════════════
   Das Bild zum Abfotografieren — und der Schlüssel zum Abtippen
   (Entscheidung E4 vom 04.10.2026, A-06).

   Eine Form für beide Stellen: den Code-Schritt der Anmeldung (wer einen
   Faktor braucht und noch keinen hat) und „Mein Konto". Das Bild kommt
   von Supabase als SVG; ohne Bild (Vorführbetrieb) steht nur der
   Schlüssel da.
   ══════════════════════════════════════════════════════════════════ */

export function Faktorbild({ e }: { e: Faktoreinrichtung }) {
  const t = useT();
  /* Der Schlüssel in Vierergruppen — so tippt man ihn ab, ohne sich zu verzählen. */
  const gruppen = e.geheimnis.replace(/(.{4})/g, "$1 ").trim();
  return (
    <div className="faktorbild">
      <ol className="faktorbild-schritte">
        <li>{t("faktor.schrittApp")}</li>
        <li>{t("faktor.schrittBild")}</li>
        <li>{t("faktor.schrittCode")}</li>
      </ol>
      {e.qr ? <img className="faktorbild-qr" src={e.qr} alt={t("faktor.bildAlt")} /> : null}
      <p className="faktorbild-schluessel">
        <span>{t("faktor.schluessel")}</span>
        <code>{gruppen}</code>
      </p>
    </div>
  );
}
